var map = {
	"./asta.jpg": 6673,
	"./atlantis.jpg": 4078,
	"./cartagena.jpg": 2412,
	"./glitch.jpg": 852,
	"./hell-bent.jpg": 4553,
	"./hello-world.jpg": 441,
	"./ick.jpg": 5754,
	"./just-super.jpg": 1401,
	"./love-game.jpg": 9943,
	"./mr-caine.jpg": 5812,
	"./oren.jpg": 3219,
	"./risen.jpg": 9203,
	"./soul-fire.jpg": 3622,
	"./the-cleaner.jpg": 3593,
	"./the-dream-escape.jpg": 3606,
	"./the-game.jpg": 7914,
	"./the-little-things.jpg": 5255,
	"./the-magic-bag.jpg": 6966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3789;